const normalizeDigits = (s) => String(s ?? "").replace(/\D/g, "");

/**
 * ID numérico da empresa para rotas da api-conciliacao / api-empresas.
 * Combo Empresa/CNPJ envia `idEmpresa`; combo legado Grupo+CNPJ usa `CNPJ` com o id numérico.
 */
export function idEmpresaFromComboIds(ids) {
  if (!ids) return null;

  const explicito = ids.idEmpresa;
  if (explicito != null && String(explicito).trim() !== "") {
    return String(explicito).trim();
  }

  const raw = ids.CNPJ;
  if (raw == null || raw === "") return null;

  if (Array.isArray(raw)) return null;

  const digits = normalizeDigits(raw);
  if (digits.length >= 11) return null;

  if (/^\d{1,9}$/.test(digits)) return digits;

  const trimmed = String(raw).trim();
  return /^\d{1,9}$/.test(trimmed) ? trimmed : null;
}
